// @ts-nocheck
import { createContext, useContext, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import HeadingInfo from './HeadingInfo';

/**
 * Set by the v2 builder: there the section already *is* the selected tree
 * node, so its own header/chevron would be a second, pointless collapse.
 * The v1 page never provides it and behaves exactly as before.
 */
export const FlattenSectionsContext = createContext(false);

export default function CollapsibleSection({
  title,
  info,
  required = false,
  defaultOpen = false,
  children,
}: {
  title: string;
  info?: string;
  required?: boolean;
  defaultOpen?: boolean;
  children: React.ReactNode;
}) {
  const flat = useContext(FlattenSectionsContext);
  const [open, setOpen] = useState(defaultOpen);
  const toggle = () => setOpen((o) => !o);

  if (flat) return <>{children}</>;

  return (
    <div className="space-y-2">
      <div className="flex w-full items-center gap-1.5 rounded-md border border-border bg-card px-4 py-2.5 text-sm font-semibold text-foreground transition-colors hover:bg-muted/50">
        <button
          type="button"
          onClick={toggle}
          aria-expanded={open}
          className="flex items-center gap-1 text-left"
        >
          {title}
          {required && (
            <span className="text-destructive" aria-label="required">
              *
            </span>
          )}
        </button>
        {info && <HeadingInfo text={info} />}
        <button
          type="button"
          onClick={toggle}
          aria-label={open ? `Collapse ${title}` : `Expand ${title}`}
          className="flex h-full flex-1 items-center justify-end pl-2"
        >
          <ChevronDown
            className={`h-4 w-4 text-muted-foreground transition-transform ${open ? 'rotate-180' : ''}`}
          />
        </button>
      </div>
      {open && <div className="rounded-md border border-border bg-card p-4">{children}</div>}
    </div>
  );
}
